module.exports = __webpack_public_path__ + "b1eb46863a41bfaf4d52dee8df5ef85f.png";